import { ETypeOfCharge } from "../../Enum/ETypeOfCharge"
import { BaseModel } from "../Generics/BaseModel"
import { GenericFoodEntity } from "./GenericFoodEntity"

export class MealEntity extends BaseModel {
  id: number

  genericFoodEntity: GenericFoodEntity

  typePayment: ETypeOfCharge

  constructor(data: Partial<MealEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.typePayment = data.typePayment ?? ETypeOfCharge.FixedValue

    this.genericFoodEntity = new GenericFoodEntity(data.genericFoodEntity)
  }
}
